import React from "react";

class BackButton extends React.Component {
  render() {
    const { text, disabled, onClick } = this.props;

    return (
      <button
        onClick={onClick}
        type="button"
        className={`back-button`}
        disabled={disabled}
      >
        <span className="">{text}</span>
      </button>
    );
  }
}

export default BackButton;
